var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    }),on:{"click":_vm.handleClickName}},[_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.datas.myValue)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }